import { useEffect } from 'react';

export const usePreventNumberInputArrowKeys = () => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        e.target.type === 'number' && 
        (e.key === 'ArrowUp' || e.key === 'ArrowDown')
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
};